import { useCallback as e, useMemo as t, useState as n } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
import { assert as r, responseHasError as i } from "@magnopus-opensource/magnopus-web-common";
import { featureFlagStore as a, isStreamingUrl as o } from "@magnopus/env";
import { openDB as s } from "/home/runner/work/oko-web/oko-web/node_modules/idb/build/index.js";
//#region src/lib/hooks/useIndexedDBCache.ts
var c = (c, l) => {
	let [u, d] = n(), [f, p] = n([]), m = a.getState().anonFeatureFlags, h = f.length > 0, { percent: g, totalBytesReceived: _, totalFileSize: v } = t(() => {
		if (f.length === 0) return {
			percent: 0,
			totalBytesReceived: 0,
			totalFileSize: 0
		};
		let e = !0, t = 0, n = 0;
		for (let r of f) r.done || (e = !1), t += r.bytesReceived, n += r.sizeInBytes === 0 ? r.bytesReceived : r.sizeInBytes;
		return {
			percent: e ? 100 : Math.round(t / n * 100),
			totalBytesReceived: t,
			totalFileSize: n
		};
	}, [f]), y = async (e, t) => {
		r(e.body);
		let n = e.body.getReader(), i = +(e.headers.get("content-length") || 0), a = {
			url: e.url,
			progress: 0,
			bytesReceived: 0,
			sizeInBytes: i,
			done: !1
		};
		p((e) => [...e, a]);
		let o = 0, s = !1, c = [];
		for (; !s;) {
			let { done: e, value: t } = await n.read();
			e ? s = !0 : (c.push(t), o += t.length), a.bytesReceived = o, a.bytesReceived !== 0 && a.sizeInBytes !== 0 && (a.progress = a.bytesReceived / a.sizeInBytes), p((e) => [...e]);
		}
		p((e) => e.filter((e) => e !== a));
		let l = new Uint8Array(o), u = 0;
		for (let e of c) l.set(e, u), u += e.length;
		return new File(c, t);
	};
	async function b(e) {
		let t = await fetch(e, o(e) && m.get("asset_security") === !0 ? { credentials: "include" } : {});
		if (i(t.status)) throw Error("Unable to fetch resource");
		let n = e.split("/");
		return await y(t, n[n.length - 1]);
	}
	let x = e(async (e, t = !1, n = 1) => {
		let r;
		if (u === void 0) {
			let e = await s(c, void 0, { upgrade: (e) => {
				e.createObjectStore(l);
			} });
			(await e.getAll(l)).forEach((t) => {
				t.lastAccessed < Math.floor(Date.now() / 1e3) - 10080 * 60 && e.delete(l, t.url);
			}), await d(() => e), r = e;
		} else r = u;
		if (r && !t) {
			let t = await r.get(l, e), i = !1;
			if (t?.blob && (t.created < Math.floor(Date.now() / 1e3) - 3600 * 24 * 3 && (i = !0), t.version < n && (i = !0), await r.put(l, {
				...t,
				lastAccessed: Math.floor(Date.now() / 1e3)
			}, e), !i)) return t.blob;
			let a = await b(e);
			return await r.put(l, {
				blob: a,
				created: a.lastModified,
				lastAccessed: a.lastModified,
				url: e,
				version: n
			}, e), a;
		} else return await b(e);
	}, []);
	return t(() => ({
		requestURLWithCache: x,
		isLoading: h,
		percent: g,
		totalBytesReceived: _,
		totalFileSize: v
	}), [
		x,
		h,
		g,
		_,
		v
	]);
};
//#endregion
export { c as useIndexedDBCache };
